import { SwitchField } from 'components/form-fields'
import React from 'react'

export function LPFilter({ showMyLP, onToggle }: { showMyLP: boolean; onToggle: () => void }) {
  return <SwitchField label="My LPs" isChecked={showMyLP} onToggle={onToggle} />
}
